// WebSocket utilities for booking system integration

const WEBSOCKET_CONFIG = {
  BROADCAST_URL: 'https://realtime-data.gotrasoft.com/api/broadcast',
  ROOM_ID: 'kuber_atv_room',
};

// Send websocket event to broadcast URL
export const sendWebSocketEvent = async (
  eventType,
  jsonPayload,
  roomId = WEBSOCKET_CONFIG.ROOM_ID
) => {
  try {
    const payload = {
      room_id: roomId,
      event_type: eventType,
      json_payload: jsonPayload,
    };

    console.log('[WEBSOCKET_SEND] Starting to send event:', payload);
    console.log('[WEBSOCKET_SEND] URL:', WEBSOCKET_CONFIG.BROADCAST_URL);

    const response = await fetch(WEBSOCKET_CONFIG.BROADCAST_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    console.log('[WEBSOCKET_SEND] Response status:', response.status);
    const result = await response.json();
    console.log('[WEBSOCKET_SEND] Response body:', result);

    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Failed to send websocket event');
    }

    console.log('[WEBSOCKET_SEND] Event sent successfully:', result);
    return true;
  } catch (error) {
    console.error('[WEBSOCKET_SEND] Failed to send event:', error);
    console.error('[WEBSOCKET_SEND] Error details:', error.message);
    return false;
  }
};

// Send booking created event
export const sendBookingCreatedEvent = async (bookingData) => {
  const eventData = {
    id: bookingData.id,
    code: bookingData.code,
    guest_name: bookingData.guest_name,
    total_pax: bookingData.guest_pax,
    reservation_date: bookingData.reservation_date,
    status: bookingData.status,
    total_price: bookingData.activities?.reduce(
      (total, activity) => total + (activity.price * activity.qty),
      0
    ) || 0,
    activities: bookingData.activities,
    agent_name: bookingData.agent?.name,
    trip_name: bookingData.trip?.name,
    created_at: bookingData.created_at,
  };

  return sendWebSocketEvent('booking_created', eventData);
};

// Send booking updated event
export const sendBookingUpdatedEvent = async (bookingData) => {
  const eventData = {
    id: bookingData.id,
    code: bookingData.code,
    guest_name: bookingData.guest_name,
    total_pax: bookingData.guest_pax,
    reservation_date: bookingData.reservation_date,
    status: bookingData.status,
    total_price: bookingData.activities?.reduce(
      (total, activity) => total + (activity.price * activity.qty),
      0
    ) || 0,
    activities: bookingData.activities,
    agent_name: bookingData.agent?.name,
    trip_name: bookingData.trip?.name,
    updated_at: bookingData.updated_at,
  };

  return sendWebSocketEvent('booking_updated', eventData);
};

// Send booking status changed event
export const sendBookingStatusChangedEvent = async (bookingData, oldStatus, newStatus) => {
  const eventData = {
    id: bookingData.id,
    code: bookingData.code,
    guest_name: bookingData.guest_name,
    old_status: oldStatus,
    new_status: newStatus,
    reservation_date: bookingData.reservation_date,
    total_pax: bookingData.guest_pax,
    changed_at: new Date().toISOString(),
  };

  return sendWebSocketEvent('booking_status_changed', eventData);
};